import React from 'react'

const ReportsPage = () => {
  return (
    <div>ReportsPage</div>
  )
}

export default ReportsPage